import React from 'react';
import { CurrentServiceProviderCard } from './current-service-provider-card';
import { UsersCard } from './users-card';
import styled from 'styled-components';

const Container = styled.div`
  padding: 1em;
`;

export function FullInfoCard() {
  return (
    <li>
      <Container>
        <CurrentServiceProviderCard />
        <UsersCard />
      </Container>
    </li>
  );
}
